export const SET_USER_INFO = "SET_USER_INFO";
export const UPDATE_ISCHECKTOKEN = "UPDATE_ISCHECKTOKEN";
export const SET_APIHOST = "SET_APIHOST";
export const SET_LEFTMENUNAV = "SET_LEFTMENUNAV";
export const SET_USERINFO = "SET_USERINFO";
export const SET_SEND_USERINFO = "SET_SEND_USERINFO";

export const SET_NAME = "SET_NAME";
export const SET_AGE = "SET_AGE";

export const SET_PERSONL = "SET_PERSONL";

export const SET_ACTIVEINDEX = "SET_ACTIVEINDEX";
export const SET_NCHANGEDATA = "SET_NCHANGEDATA";
export const SET_QUERYSEARCH = "SET_QUERYSEARCH";

export const SET_QUESTIONCHANGE = "SET_QUESTIONCHANGE";
export const SET_DELQUESTION = "SET_DELQUESTION";

export const SET_ISITCSCENCE = "SET_ISITCSCENCE";
export const SET_Customer_Keyword = "SET_Customer_Keyword";
export const Change_Cate = "Change_Cate";
